import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../views/authentication/authentication.service';

@Injectable()
export class AppSidebarFilterService {

  @Output() filterData: EventEmitter<any> = new EventEmitter();
  @Output() selectedFilter: any = {};
  constructor(private http: HttpClient, private authService: AuthenticationService) { }

  getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.authService.token);
    return headers;
  }

  setFilterData(filter){
    this.selectedFilter = filter;
    this.filterData.emit(filter);
  }

  getCarriersLabels(): Observable<any>  {
    return this.http.get(environment.API + '/carriers-labels/', { headers: this.getHeaders() });
  }
  getChargeTypes(): Observable<any>  {
    return this.http.get(environment.API + '/filter/friendly-names/', { headers: this.getHeaders() });
  }
  getAccounts(): Observable<any>  {
    return this.http.get(environment.API + '/filter/accounts/', { headers: this.getHeaders() });
  }
  getCostCenters(): Observable<any>  {
    return this.http.get(environment.API + '/filter/cost-centers/', { headers: this.getHeaders() });
  }
  getTenants(): Observable<any>  {
    return this.http.get(environment.API + '/filter/tenants/', { headers: this.getHeaders() });
  }
  getHoldings(): Observable<any>  {
    return this.http.get(environment.API + '/filter/holdings/', { headers: this.getHeaders() });
  }
  getCorporateUnits(): Observable<any>  {
    return this.http.get(environment.API + '/filter/corporate-units/', { headers: this.getHeaders() });
  }
  getPeople(): Observable<any>  {
    return this.http.get(environment.API + '/filter/people-by-tenant-id/', { headers: this.getHeaders() });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-filter/app-sidebar-filter.service.ts